// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shelves[data-v-eaa473da]{margin-top:2rem;display:flex;flex-direction:column}.no-padding[data-v-eaa473da]{margin:0 -16px}.shelves-container[data-v-eaa473da]{padding:1rem}.hide-thumbnails[data-v-eaa473da] .card-image{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
